// hooks/useStatusEOCheck.js
// Pengecekan berkala status_EO - logout langsung tanpa dialog jika akun dinonaktifkan
// Backoff saat network error: kurangi request berulang saat server down

import { useEffect, useRef } from "react";
import axios from "axios";
import { API_ESA_OFFICE } from "utils";
import { forceLogoutInactive } from "utils/forceLogoutInactive";
import { isNetworkOrServerError } from "utils/networkErrorUtils";

const CHECK_INTERVAL_MS = 15 * 60 * 1000; // 15 menit
const NETWORK_ERROR_BACKOFF_MS = 60000; // 60 detik - jangan spam check-status saat server down

const getIsPublicRoute = () => {
  const hash = window.location.hash || "";
  return (
    hash.includes("/survey/") ||
    hash.includes("/publik/") ||
    hash.includes("/download/")
  );
};

export const useStatusEOCheck = (navigate, options = {}) => {
  const intervalMs = options.intervalMs || CHECK_INTERVAL_MS;
  const intervalRef = useRef(null);
  const lastNetworkErrorAt = useRef(0);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user || getIsPublicRoute()) return;

    const checkStatus = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      if (
        lastNetworkErrorAt.current > 0 &&
        Date.now() - lastNetworkErrorAt.current < NETWORK_ERROR_BACKOFF_MS
      ) {
        return; // Skip saat dalam backoff
      }

      try {
        const response = await axios.get(`${API_ESA_OFFICE}users/check-status`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        const statusEO = response.data?.status_EO || "Aktif";
        if (statusEO !== "Aktif") {
          forceLogoutInactive();
        }
      } catch (error) {
        if (isNetworkOrServerError(error)) {
          lastNetworkErrorAt.current = Date.now();
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkStatus();
      }
    };

    checkStatus();
    intervalRef.current = setInterval(checkStatus, intervalMs);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [intervalMs]);
};
